import request from "./curl";

export default {
  name: "report_issue_dialog",
  props:['showDialog', 'data'],
  data: () => ({
    groups:[],
    snackbar:false,
    err_msg:'',
    comment:'',
    loading:false
    
  }),
  computed: {
    dialog:{
      get:function(){
        return this.showDialog;
      },
      set:function(value){
        this.$emit("dialogClose", value);
      }
    },
    userData() {
        return this.$store.getters.userData;
    }
  },
  mounted() {
    
  },
  methods: {
    /*
    * report_send
    */
    report_issue_submit(){
      this.loading  = true;
      var report_issue_data = new FormData();
      report_issue_data.append("chat_user_id", this.userData.user_id);
      report_issue_data.append("module_obj_id", this.data.module_obj_id);
      report_issue_data.append("content_text", this.data.content_text);
      report_issue_data.append("module_type", this.data.module_type);
      if(this.comment){
        report_issue_data.append("comment", this.comment);
      }
      request.curl(this, "report_issue", report_issue_data)
      .then(response => {
        if(response.resp_status){
          this.err_msg = response.resp_msg;
          this.snackbar = true;
        }
        this.loading = false;
        this.dialog = false;
     });
    }
  }
}
